import SectionFirstPage from '@/components/common/SectionFirstPage';
import SectionUserCommunity from '@/components/pages/ClientApplicationAreas/SectionUserCommunity';
import SectionWeServeFor from '@/components/pages/ClientApplicationAreas/SectionWeServeFor';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ClientApplicationAreas = () => {
  const { t } = useTranslation();
  return (
    <div>
      <SectionFirstPage
        title={
          <h1>
            {t('Client &')}
            <br />
            {t('Application')}
            <br />
            <span>{t('Areas')}</span>
          </h1>
        }
        desc={t(
          'Furthermore, we are a leading technology service provider in Vietnam, collaborating with top partners such as Defi Agents AI, SEED, Movements, Thruster, Bitlayer, SynFutures, Gomble, SETAI Agents, Dmission, Piratopia, NERO Chain, and many others. '
        )}
      />
      <SectionUserCommunity />
      <SectionWeServeFor />
    </div>
  );
};

export default React.memo(ClientApplicationAreas);
